import React from "react";
import { Check, Field } from "./Fields";
import { SettingType } from "../constants";

/** Wyświetla opcje zadeklarowane przez wtyczkę w katalogu backendu. */
export default function PluginSettings({ settings, config, onChange }) {
  const sections = [...new Set(settings.map((setting) => setting.section))];
  return sections.map((section) => (
    <section key={section} className="card premium-panel" aria-label={section}>
      <h2>{section}</h2>
      {settings
        .filter((setting) => setting.section === section)
        .map((setting) =>
          setting.type === SettingType.BOOLEAN ? (
            <Check
              key={setting.key}
              label={setting.label}
              checked={config[setting.key]}
              onChange={(event) => onChange(setting.key, event.target.checked)}
            />
          ) : (
            <Field
              key={setting.key}
              label={setting.label}
              multiline={setting.multiline}
              value={config[setting.key]}
              onChange={(event) => onChange(setting.key, event.target.value)}
            />
          ),
        )}
    </section>
  ));
}
